import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;
const ROUTE = API_URL + "/GettingStarted"

const CHECK_IMPLEMENTATION_TYPE = ROUTE + "/CheckImplementationType"
const GET_GETTING_STARTED_LIBRARY_POSTS = ROUTE + "/GetGettingStartedLibraryPostsIds"


const CheckImplementationType = (data, software) => {
    let url = prepareFilterQuery(CHECK_IMPLEMENTATION_TYPE, data, software);
    return axios.get(url);
}

const GetGettingStartedLibraryPosts = () => {
    return axios.get(GET_GETTING_STARTED_LIBRARY_POSTS)
}

const prepareFilterQuery = (url, data, software) => {
    url += `?software=${software}`
    url += `&builderOrBuyer=${data[1]}`
    url += `&hostingProvider=${data[2]}`
    url += `&forSale=${data[3]}`
    url += `&stakeHolderType=${data[4]}`
    return url
}

export const gettingStartedService = {
    CheckImplementationType,
    GetGettingStartedLibraryPosts
}